import hero from "@/images/hero.jpg";
import karyaPolos from "@/images/karya-polos.png";
import karyaKlasik from "@/images/karya-klasik.png";
import karyaPlus from "@/images/karya-plus.png";
import daya from "@/images/daya.jpg";
import hadap from "@/images/hadap.jpg";
import siku from "@/images/siku.jpg";
import raya from "@/images/raya.png";
import clientsHero from "@/images/clients/clients-hero.jpg";
import greenshield1 from "@/images/clients/greenshield-1.jpg";
import greenshield2 from "@/images/clients/greenshield-2.jpg";
import greenshield3 from "@/images/clients/greenshield-3.jpg";
import kreditplus1 from "@/images/clients/kreditplus-1.jpg";
import kreditplus2 from "@/images/clients/kreditplus-2.jpg";
import kreditplus3 from "@/images/clients/kreditplus-3.jpg";
import hensel1 from "@/images/clients/hensel-1.jpg";
import hensel2 from "@/images/clients/hensel-2.jpg";
import hensel3 from "@/images/clients/hensel-3.jpg";
import rapih from "@/images/rapih.jpg";
import alur from "@/images/alur.jpg";
import sinar from "@/images/sinar.jpg";
import putar from "@/images/putar.jpg";
import assemblyHeroImg from "@/images/assembly/hero.jpg";
import assemblyPoster from "@/images/assembly/video-poster.jpg";
import assemblyPartsPhoto from "@/images/assembly/parts-photo.jpg";
import assemblyExploded from "@/images/assembly/exploded-diagram.png";
import step01 from "@/images/assembly/step-01.jpg";
import step02 from "@/images/assembly/step-02.jpg";
import step03 from "@/images/assembly/step-03.jpg";
import step04 from "@/images/assembly/step-04.jpg";
import step05 from "@/images/assembly/step-05.jpg";
import step06 from "@/images/assembly/step-06.jpg";
import step07 from "@/images/assembly/step-07.jpg";
import step08 from "@/images/assembly/step-08.jpg";
import step09 from "@/images/assembly/step-09.jpg";
import step10 from "@/images/assembly/step-10.jpg";
import step11 from "@/images/assembly/step-11.jpg";
import step12 from "@/images/assembly/step-12.jpg";
import step13 from "@/images/assembly/step-13.jpg";
import step14 from "@/images/assembly/step-14.jpg";
import step15 from "@/images/assembly/step-15.jpg";

export const heroImage = hero;
export const clientsHeroImage = clientsHero;
export const assemblyHero = assemblyHeroImg;
export const assemblyVideoPoster = assemblyPoster;
export const partsPhoto = assemblyPartsPhoto;
export const explodedDiagram = assemblyExploded;

/** Assembly step imageKey (step-01 … step-15) -> asset URL. */
export const assemblyImages: Record<string, string> = {
  "step-01": step01,
  "step-02": step02,
  "step-03": step03,
  "step-04": step04,
  "step-05": step05,
  "step-06": step06,
  "step-07": step07,
  "step-08": step08,
  "step-09": step09,
  "step-10": step10,
  "step-11": step11,
  "step-12": step12,
  "step-13": step13,
  "step-14": step14,
  "step-15": step15,
};

/** Client gallery imageKey -> asset URL (keys match @kanata/shared clients[].imageKeys). */
export const clientImages: Record<string, string> = {
  "greenshield-1": greenshield1,
  "greenshield-2": greenshield2,
  "greenshield-3": greenshield3,
  "kreditplus-1": kreditplus1,
  "kreditplus-2": kreditplus2,
  "kreditplus-3": kreditplus3,
  "hensel-1": hensel1,
  "hensel-2": hensel2,
  "hensel-3": hensel3,
};

/**
 * imageKey (from @kanata/shared catalog) -> asset URL.
 * Items whose key is absent here render an icon fallback instead
 * (e.g. accessories without dedicated photography yet).
 */
export const productImages: Record<string, string> = {
  "karya-polos": karyaPolos,
  "karya-klasik": karyaKlasik,
  "karya-plus": karyaPlus,
  daya,
  hadap,
  siku,
  raya,
  rapih,
  alur,
  sinar,
  putar,
};

/**
 * Resolve a catalogue imageKey to an asset URL.
 *
 * Returns undefined rather than a placeholder for an unknown key, so callers
 * decide what a missing photo looks like in their own layout instead of every
 * grid inheriting the same grey box.
 */
export function img(key: string): string | undefined {
  return productImages[key];
}
